import { NgModule } from '@angular/core';
import { routing } from 'pages/static-pages/static-pages.route';
import { StaticPagesComponent } from 'pages/static-pages/static-pages.component';
import { TermsAndConditionsModule } from 'pages/static-pages/term-and-conditions/terms-and-conditions.module';
import { TermsAndConditionsPageComponent } from 'pages/static-pages/term-and-conditions-page/term-and-conditions-page.component';
import { HeaderModule } from 'components/header/header.module';
import { DisabledCookiesComponent } from './disabled-cookies/disabled-cookies.component';

@NgModule({
  imports: [TermsAndConditionsModule, HeaderModule, routing],
  declarations: [StaticPagesComponent, TermsAndConditionsPageComponent, DisabledCookiesComponent],
  providers: [],
})
export class StaticPagesModule {}
